// extracted by css-extract-rspack-plugin
export default {"actionsButton":"mITJm8t6MgIwElN5"};